import "./Header.css"

function Header() {
  return (
    <header className="header">
      <div className="container header-container">
        <h1 className="header-title">Badkul Technology</h1>
        <div className="header-button">JWT Decoder</div>
      </div>
    </header>
  )
}

export default Header
